// Identifier helpers used by loop parser and placeholder scanner.
// Example key formats: "i", "bp.size", "--spaceScale".

// Validate placeholder key syntax: `name` or `name.part`.
export function isValidLoopPlaceholderKey(key: string): boolean {
  // Regex validates dotted keys with optional internal hyphen groups.
  return /^[a-zA-Z_][a-zA-Z0-9_]*(?:-[a-zA-Z0-9_]+)*(?:\.[a-zA-Z_][a-zA-Z0-9_]*(?:-[a-zA-Z0-9_]+)*)*$/.test(key)
}

// Check whether character can start one identifier segment.
export function isLoopIdentifierStart(char: string): boolean {
  // Return true when character is a valid identifier starter.
  return /[a-zA-Z_]/.test(char)
}

// Check whether character can continue one identifier segment.
export function isLoopIdentifierChar(char: string): boolean {
  // Return true when character is valid in plain identifier body.
  return /[a-zA-Z0-9_]/.test(char)
}
